import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, BookOpen } from 'lucide-react';
import Pricing from '../sections/Pricing';

// Dedicated full-screen pricing page (route: /pricing)
// Same content as the folio chapter, laid out for standard desktop display.
export default function PricingPage() {
    const navigate = useNavigate();
    return (
        <div
            className="min-h-screen"
            data-testid="pricing-page"
            style={{
                background:
                    'radial-gradient(60% 50% at 20% 0%, rgba(183,156,255,0.14) 0%, transparent 60%), radial-gradient(50% 40% at 90% 100%, rgba(59,68,30,0.4) 0%, transparent 60%), var(--moss-dark)',
            }}
        >
            {/* Page header */}
            <header className="sticky top-0 z-40 px-4 lg:px-8 pt-5">
                <div className="flex items-center justify-between gap-4 rounded-lg border border-[color:var(--moss-deep)]/20 bg-[color:var(--parchment)] shadow-[0_2px_0_var(--moss-deep),0_10px_30px_-15px_rgba(0,0,0,0.35)] px-4 lg:px-6 py-3 max-w-7xl mx-auto">
                    <a href="/" className="flex items-center shrink-0" data-testid="pricing-brand">
                        <img
                            src="https://customer-assets-jt897jd0.emergentagent.net/job_journal-flip-app/artifacts/mr8l0zow_studyfolio%20dpi%20500%20%20png.png"
                            alt="Studyfolio"
                            className="h-9 lg:h-10 w-auto object-contain select-none"
                        />
                    </a>
                    <button
                        onClick={() => navigate('/')}
                        data-testid="back-to-folio"
                        className="min-h-[44px] flex items-center gap-2 mono text-[10px] px-4 py-2 rounded-full border border-[color:var(--moss-deep)]/30 text-[color:var(--moss-dark)] hover:border-[color:var(--lavender-deep)] hover:text-[color:var(--lavender-deep)] transition"
                    >
                        <ArrowLeft size={12} /> <BookOpen size={12} /> BACK TO FOLIO
                    </button>
                </div>
            </header>

            {/* Full-width pricing content */}
            <motion.main
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: [0.83, 0, 0.17, 1] }}
                className="max-w-7xl mx-auto px-4 lg:px-8 py-10"
            >
                <div className="paper grain-light rounded-lg border border-[color:var(--moss-deep)]/30 shadow-[0_40px_80px_-30px_rgba(0,0,0,0.5)] px-5 sm:px-10 lg:px-14 py-10">
                    <Pricing />
                </div>
                <div className="mono text-[10px] text-[color:var(--parchment)]/60 text-center mt-6">
                    © MMXXVI Folio &amp; Co. · Hyderabad, Telangana, India · All rights reserved.
                </div>
            </motion.main>
        </div>
    );
}
